import React from "react";

// 게시판 탭 버튼 컴포넌트
const BoardTabs = ({ boardType, setBoardType }) => {
  return (
    <div className="tab-group">

      {/* 전체 게시글 탭 */}
      <button
        className={`tab-button ${boardType === "all" ? "active" : ""}`}
        onClick={() => setBoardType("all")}
      >
        전체
      </button>

      {/* 분실물 탭 */}
      <button
        className={`tab-button ${boardType === "lost" ? "active" : ""}`}
        onClick={() => setBoardType("lost")}
      >
        분실물
      </button>

      {/* 습득물 탭 */}
      <button
        className={`tab-button ${boardType === "found" ? "active" : ""}`}
        onClick={() => setBoardType("found")}
      >
        습득물
      </button>

      {/* 주인찾음 탭 */}
      <button
        className={`tab-button ${boardType === "completed" ? "active" : ""}`}
        onClick={() => setBoardType("completed")}
      >
        주인찾음
      </button>

    </div>
  );
};

export default BoardTabs;